import { InputMask } from "@/components/Form/Base/maskedInput.component";

const zipCodeFormatting: Record<string, InputMask> = {
    BE: {
        regex: "^[0-9]{4}$",
        mask: "9999",
        placeholder: "_"
    },
    FR: {
        regex: "^[0-9]{5}$",
        mask: "99999",
        placeholder: "_"
    },
    NL: {
        regex: "^[0-9]{4} [a-zA-Z]{2}$",
        mask: "9999 aa",
        placeholder: "_"
    },
    DE: {
        regex: "^[0-9]{5}$",
        mask: "99999",
        placeholder: "_"
    },
    LU: {
        regex: "^[0-9]{4}$",
        mask: "9999",
        placeholder: "_"
    },
    DEFAULT: {
        regex: "^[A-Za-z0-9 -]{4,8}$",
        mask: "",
        placeholder: undefined
    }
};

export const getCountryFormatting = (
    countryCode: keyof typeof zipCodeFormatting = "BE"
): InputMask => {
    const formatting = zipCodeFormatting[countryCode];
    if (formatting) {
        return formatting;
    }
    return zipCodeFormatting.DEFAULT;
};

export const checkCountryZipCode = (
    countryCode: keyof typeof zipCodeFormatting,
    zipCode: string
) => {
    const countryRegex = getCountryFormatting(countryCode)?.regex;

    return countryRegex ? new RegExp(countryRegex).test(zipCode) : true;
};
